import { CloseButton } from '@components/utility/buttons';
import { Dialog, DialogContent, DialogProps, DialogTitle, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const LearnMoreDialog = (props: DialogProps) => {
    return (
        <Dialog
            {...props}
            slotProps={{
                paper: {
                    className: 'min-w-[828px] min-h-[439px] px-10 pb-6 pt- rounded-2xl top-',
                },
            }}
            disableEscapeKeyDown
        >
            <CloseButton
                className="absolute size-10 flex"
                color="black"
                onClick={() => props.onClose?.({}, 'escapeKeyDown')}
            />
            <DialogTitle className="w-full flex justify-center pt-14 ">
                <Typography className="font-museo" fontWeight={400} fontSize={32}>
                    <FormattedMessage id="event.temporary.title" defaultMessage="Temporary Registration" />
                </Typography>
            </DialogTitle>
            <DialogContent
                className="rounded-lg p-6 flex flex-col gap-4"
                sx={{
                    boxShadow: '0px 1px 3px 0px #A6AFC366',
                }}
            >
                <Typography className="font-museo" fontWeight={600} fontSize={16}>
                    <FormattedMessage id="event.temporary.howItWorks" defaultMessage="How it works:" />
                </Typography>
                <div className="rounded-[4px] bg-neutral-100">
                    <ul className="list-disc px-[10px]">
                        <li className="p-[10px] ml-8">
                            <Typography className="-ml-2 font-museo" fontWeight={300}>
                                <FormattedMessage
                                    id="event.temporary.registrationRequirement"
                                    defaultMessage="<semibold>Registration requirement:</semibold> You must be registered for at least one prerequisite event before you can register for this event"
                                    values={{ semibold: (chunks) => <span className="font-semibold">{chunks}</span> }}
                                />
                            </Typography>
                        </li>
                        <li className="p-[10px] ml-8">
                            <Typography className="-ml-2 font-museo" fontWeight={300}>
                                <FormattedMessage
                                    id="event.temporary.duringRegistration"
                                    defaultMessage="<semibold>During registration:</semibold> You'll see a list of prerequisite events you're registered for. You only need to attend one of them to confirm your registration"
                                    values={{ semibold: (chunks) => <span className="font-semibold">{chunks}</span> }}
                                />
                            </Typography>
                        </li>
                        <li className="p-[10px] ml-8">
                            <Typography className="-ml-2 font-museo" fontWeight={300}>
                                <FormattedMessage
                                    id="event.temporary.yourSpotIsReserved"
                                    defaultMessage="<semibold>Your spot is reserved:</semibold> Your temporary registration holds your spot in this event"
                                    values={{ semibold: (chunks) => <span className="font-semibold">{chunks}</span> }}
                                />
                            </Typography>
                        </li>
                        <li className="p-[10px] ml-8">
                            <Typography className="-ml-2 font-museo" fontWeight={300}>
                                <FormattedMessage
                                    id="event.temporary.automaticConfirmation"
                                    defaultMessage="<semibold>Automatic confirmation:</semibold> Once you attend one of the prerequisite events, your registration will be automatically confirmed"
                                    values={{ semibold: (chunks) => <span className="font-semibold">{chunks}</span> }}
                                />
                            </Typography>
                        </li>
                    </ul>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export { LearnMoreDialog };
